import { Product } from 'app/ts/clientDto/Product';
export class InteriorProductCategory {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly imageUrl: string,
    public readonly products: Product[],
  ) {}
}
